"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const options_1 = require("./options");
const duration = 250;
const defaultStyle = {
    [options_1.transitions.FADE]: {
        transition: `opacity ${duration}ms ease`,
        opacity: 0,
    },
    [options_1.transitions.SCALE]: {
        transform: 'scale(1)',
        transition: `all ${duration}ms ease-in-out`,
    },
};
const defaultTransitionStyles = {
    [options_1.transitions.FADE]: {
        entering: { opacity: 0 },
        entered: { opacity: 1 },
    },
    [options_1.transitions.SCALE]: {
        entering: { transform: 'scale(0)' },
        entered: { transform: 'scale(1)' },
        exiting: { transform: 'scale(0)' },
        exited: { transform: 'scale(1)' },
    },
};
function Transtion({ children, type, transitionStyles = defaultTransitionStyles, ...props }) {
    const ref = (0, react_1.useRef)(null);
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.Transition, { nodeRef: ref, ...props, timeout: duration, children: (state) => ((0, jsx_runtime_1.jsx)("div", { ref: ref, style: {
                ...defaultStyle[type],
                ...transitionStyles[type][state],
                ...transitionStyles.default,
            }, children: children })) }));
}
exports.default = Transtion;
